const svgArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12.8" viewBox="0 0 8 12.8">
  <g id="Group_583" data-name="Group 583" transform="translate(-1679 1280) rotate(-90)">
    <path id="Polygon_52" data-name="Polygon 52" d="M6.4,0l6.4,8H0Z" transform="translate(1280 1687) rotate(180)" fill="#005272"/>
  </g>
</svg>`;

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.block__table').forEach(blockTable => {
        const wrapper = blockTable.querySelector('.table-responsive');
        const thead = blockTable.querySelector('thead');
        const tbody = blockTable.querySelector('tbody');
        if (!wrapper || !thead) return;

        const indicator = document.createElement('div');
        indicator.className = 'table-scroll-indicator';
        indicator.setAttribute('aria-hidden', 'true');
        indicator.innerHTML = svgArrow;
        blockTable.appendChild(indicator);

        const bodyIndicator = tbody ? document.createElement('div') : null;
        if (bodyIndicator) {
            bodyIndicator.className = 'table-scroll-body-indicator';
            bodyIndicator.setAttribute('aria-hidden', 'true');
            blockTable.appendChild(bodyIndicator);
        }

        const update = () => {
            const overflows = wrapper.scrollWidth > wrapper.clientWidth;
            const atEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;
            const visible = overflows && !atEnd;

            indicator.style.height = thead.offsetHeight + 'px';
            indicator.style.display = visible ? 'flex' : 'none';

            if (bodyIndicator) {
                bodyIndicator.style.top = (thead.offsetTop + thead.offsetHeight) + 'px';
                bodyIndicator.style.height = tbody.offsetHeight + 'px';
                bodyIndicator.style.display = visible ? 'block' : 'none';
            }
        };

        update();
        wrapper.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(wrapper);
    });
});
